import { H6, LI, P } from "../../../../../AbstractElements";
import { FileFolderItemProp } from "../../../../../Types/FileManagerType";

const FolderListItem:React.FC<FileFolderItemProp> = ({ item }) => {
  return (
    <LI className="folder-box">
      <div className="d-block">
        <i className={`f-44 fa fa-${item.folderClass} txt-warning`} />
        <i className="fa fa-ellipsis-v me-0 f-14 ellips" />
        <div className="mt-3">
          <H6>{item.title}</H6>
          <P>
            {item.folderFiles}
            <span className="pull-right">
              <i className="fa fa-clock-o" />
              {item.folderTime}
            </span>
          </P>
        </div>
      </div>
    </LI>
  );
};
export default FolderListItem;
